module.exports = __webpack_public_path__ + "img/3d-glasses-4.a45b45ad.png";